import React from 'react';
import {View} from 'react-native';
import {IStateProps} from './model';
import {dateFormats} from '../../../shared/constants/date';
import {datePipe} from '../../../shared/pipes/date';
import {Text} from '../../../shared/components/text';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {useStyles} from '../../../shared/hooks/styles';
import {useNavigation} from '@react-navigation/native';
import {useNotificationPressHandler} from '../hooks/useNotificationPressHandler';
import {Button} from '../../../shared/components/button';
import {DeviceSize} from '../../../shared/theme/helpers';
import {Container} from '../../../shared/components/container';
import Screen from '../../../shared/components/screen';
import {Markdown} from '../../../shared/components/markdown';

export default ({notification}: IStateProps) => {
  const navigation = useNavigation();
  const handlePress = useNotificationPressHandler(notification, navigation);
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        marginTop: 28,
        marginBottom: 37,
      },
      buttonWrap: {
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 20,
      },
      button: mediaOnly(DeviceSize.mobile, {width: '100%'}, {maxWidth: 328}),
      time: {
        ...theme.fonts.body,
        color: theme.color.gray500,
        textAlign: 'right',
        marginTop: 20,
      },
    };
  });

  if (!notification) return null;

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <Container style={styles.container}>
          <Markdown>{notification.text}</Markdown>
          {handlePress && (
            <View style={styles.buttonWrap}>
              <Button
                id='notification-description'
                style={styles.button}
                type='secondary'
                text='Подробнее'
                onPress={handlePress}
              />
            </View>
          )}
          <Text style={styles.time}>{datePipe(notification.dateTime, dateFormats.fullDateWithTime)}</Text>
        </Container>
      </CustomScrollView>
    </Screen>
  );
};
